import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_RESET,
  ORDER_USERS_LIST_REQUEST,
  ORDER_USERS_LIST_SUCCESS,
  ORDER_USERS_LIST_FAIL,
  ORDER_USERS_LIST_RESET,
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAIL,
} from "../actions/constants/order";

export const orderCreateReducer = (
  state: any = { orderItems: [] },
  action: any
) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return {
        loading: true,
      };
    case ORDER_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        order: action.payload,
      };
    case ORDER_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const orderDetailsReducer = (
  state = { loading: true, orderItems: [] },
  action: any
) => {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ORDER_DETAILS_SUCCESS:
      return {
        loading: false,
        order: action.payload,
      };
    case ORDER_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const orderPayReducer = (state = {}, action: any) => {
  switch (action.type) {
    case ORDER_PAY_REQUEST:
      return {
        loading: true,
      };
    case ORDER_PAY_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case ORDER_PAY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_PAY_RESET:
      return {};
    default:
      return state;
  }
};

export const orderListReducer = (state: any = { orders: [] }, action: any) => {
  const normalizeUsersOrdersPayload = (payload: any) => {
    if (Array.isArray(payload)) {
      return {
        orders: payload,
        pagination: null,
        availableYears: [],
      };
    }

    return {
      orders: Array.isArray(payload?.orders) ? payload.orders : [],
      pagination: payload?.pagination || null,
      availableYears: Array.isArray(payload?.availableYears)
        ? payload.availableYears
        : [],
    };
  };

  const dedupeOrdersById = (orders: any[]) => {
    const seen = new Set<string>();
    return orders.filter((order: any) => {
      const orderId = String(order?._id || "");
      if (!orderId) {
        return true;
      }
      if (seen.has(orderId)) {
        return false;
      }
      seen.add(orderId);
      return true;
    });
  };

  switch (action.type) {
    case ORDER_USERS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        orders: state.orders || [],
        pagination: state.pagination || null,
        availableYears: state.availableYears || [],
      };
    case ORDER_LIST_REQUEST:
      return {
        loading: true,
      };
    case ORDER_USERS_LIST_SUCCESS: {
      const normalized = normalizeUsersOrdersPayload(action.payload);
      const orders = action.append
        ? dedupeOrdersById([...(state.orders || []), ...normalized.orders])
        : normalized.orders;
      return {
        loading: false,
        orders,
        pagination: normalized.pagination,
        availableYears:
          normalized.availableYears.length > 0
            ? normalized.availableYears
            : state.availableYears || [],
      };
    }
    case ORDER_LIST_SUCCESS:
      return {
        loading: false,
        orders: action.payload,
      };
    case ORDER_USERS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ORDER_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_USERS_LIST_RESET:
      return { orders: [], pagination: null, availableYears: [] };
    default:
      return state;
  }
};
